import React, { useState, useEffect } from 'react';
import '../../App.css'; // Ensure we have access to global styles
import logo from '../../assets/logo.png';
import { ManageCategories } from './components/manage-category';
import { ManagePromotions } from './components/manage-promotion';
import { ManageProducts } from './components/manage-products';
import { signOut } from 'firebase/auth';
import { useNavigate, useLocation } from 'react-router-dom';
import { auth } from '../../firebase';
import { ManageContactsUs } from './components/manage-contacts-us';
import { brandName } from '../../modules/modules';
import { QuickAdverts } from './components/carousel-advert';

const AdminDashboard = () => {
    const location = useLocation();
    const [activeTab, setActiveTab] = useState(location.state?.openTab || 'quick-adverts');
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        if (location.state?.openTab) {
            setActiveTab(location.state.openTab);
        }
    }, [location.state]);

    const toggleSidebar = () => {
        setIsSidebarOpen(!isSidebarOpen);
    };

    const handleLogout = () => {
        signOut(auth);
        navigate('/');
    };

    const renderContent = () => {
        switch (activeTab) {
            case 'quick-adverts':
                return <QuickAdverts />;
            case 'manage-categories':
                return <ManageCategories />;
            case 'manage-promotions':
                return <ManagePromotions />;
            case 'manage-products':
                return <ManageProducts />;
            case 'contact-infos':
                return <ManageContactsUs />;
            default:
                return <QuickAdverts />;
        }
    };

    return (
        <div className="admin-dashboard">
            {/* Mobile Header */}
            <div className="admin-mobile-header">
                <button className="menu-toggle" onClick={toggleSidebar}>
                    ☰
                </button>
                <div className="mobile-brand">
                    <img src={logo} alt="Daty Abaya" className="mobile-logo" />
                    <h2>DatyAbayaTZ</h2>
                </div>
            </div>

            {/* Sidebar */}
            <aside className={`admin-sidebar ${isSidebarOpen ? 'open' : ''}`}>
                <div className="sidebar-header">
                    <div className="brand-container">
                        <img src={logo} alt="Daty Abaya" className="sidebar-logo" />
                        <h2>DatyAbayaTZ</h2>
                    </div>
                    <button className="close-sidebar" onClick={toggleSidebar}>×</button>
                </div>
                <nav className="sidebar-nav">
                    <button
                        className={activeTab === 'quick-adverts' ? 'active' : ''}
                        onClick={() => { setActiveTab('quick-adverts'); setIsSidebarOpen(false); }}
                    >
                        Quick Adverts
                    </button>
                    <button
                        className={activeTab === 'manage-categories' ? 'active' : ''}
                        onClick={() => { setActiveTab('manage-categories'); setIsSidebarOpen(false); }}
                    >
                        Manage Categories
                    </button>
                    <button
                        className={activeTab === 'manage-promotions' ? 'active' : ''}
                        onClick={() => { setActiveTab('manage-promotions'); setIsSidebarOpen(false); }}
                    >
                        Manage Promotions
                    </button>
                    <button
                        className={activeTab === 'manage-products' ? 'active' : ''}
                        onClick={() => { setActiveTab('manage-products'); setIsSidebarOpen(false); }}
                    >
                        Manage Products
                    </button>
                    <button
                        className={activeTab === 'contact-infos' ? 'active' : ''}
                        onClick={() => { setActiveTab('contact-infos'); setIsSidebarOpen(false); }}
                    >
                        Contact Infos
                    </button>
                    <button
                        className="sidebar-action-btn sidebar-action-btn--secondary"
                        onClick={() => navigate('/')}
                    >
                        back to home
                    </button>
                    <button
                        className="sidebar-action-btn sidebar-action-btn--danger"
                        onClick={handleLogout}
                    >
                        logout
                    </button>
                </nav>
            </aside>

            {/* Main Content */}
            <main className="admin-content">
                <div className="content-wrapper">
                    {renderContent()}
                </div>
                <AdminFooter />
            </main>

            {/* Overlay for mobile sidebar */}
            {isSidebarOpen && <div className="sidebar-overlay" onClick={toggleSidebar}></div>}
        </div>
    );
};

const AdminFooter = () => {
    return (
        <footer className="admin-footer">
            <div className="footer-content">
                <p>&copy; {new Date().getFullYear()} <span className="highlight">{brandName}</span>. All rights reserved.</p>
                <p className="footer-tagline">Elegant & Modest Fashion</p>
            </div>
        </footer>
    );
};

export default AdminDashboard;
